import { Controller } from "@hotwired/stimulus"

// Displays a simple alert message without inline JavaScript.
export default class extends Controller {
  static values = {
    message: String
  }

  show(event) {
    if (event) event.preventDefault()
    if (!this.hasMessageValue) return

    window.alert(this.messageValue)
  }
}
